<template>
  <div id="app" style="min-height: 100%;">
    <router-view />
  </div>
</template>
<script>
export default {
  name: 'app'
}
</script>
